/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import linkBuilder from "../../modules/linkBuilder"

const SITE_URL = "https://www.mkbservicedesk.nl"

function Seo({ title, description, canonicalUrl, noIndex }) {
  const { site, organizationLogo } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
        }
      }
      organizationLogo: file(relativePath: { eq: "logo-mkbservicedesk.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, width: 537, height: 60, quality: 100)
        }
      }
    }
  `)

  const siteTitle = site.siteMetadata.title
  const metaDescription = description || site.siteMetadata.description
  title = title ? `${title} - ${siteTitle}` : siteTitle

  const logoSrc =
    organizationLogo?.childImageSharp?.gatsbyImageData?.images?.fallback?.src

  // Site-wide Organization structured data (single source of truth).
  const organizationLdJson = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "MKB Servicedesk",
    url: SITE_URL,
    ...(logoSrc && { logo: `${SITE_URL}${logoSrc}` }),
    email: "redactie@mkbservicedesk.nl",
    telephone: "088 - 652 00 55",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Reitseplein 1",
      postalCode: "5037 AA",
      addressLocality: "Tilburg",
      addressCountry: "NL",
    },
    sameAs: [
      "https://www.linkedin.com/company/220526",
      "https://www.instagram.com/mkbservicedesk",
      "https://www.facebook.com/MKBServicedesk",
      "https://www.youtube.com/user/MKBservicedesk",
      "https://www.tiktok.com/@mkbservicedesk",
      "https://x.com/MKBServicedesk",
    ],
  }

  // Ensure the canonical always points at the final 200-URL: canonical host
  // (https://www.), no duplicate slashes, no trailing slash.
  const canonical = canonicalUrl && linkBuilder.normalizeUrl(canonicalUrl)

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={metaDescription} />
      {noIndex && <meta name="robots" content="noindex" />}
      {!noIndex && <meta name="robots" content="max-image-preview:large" />}
      {canonical && <link rel="canonical" href={canonical} />}
      <script type="application/ld+json">
        {JSON.stringify(organizationLdJson)}
      </script>
    </Helmet>
  )
}

export default Seo
